import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { buildHttpParams } from 'app/core/utils/http-util';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ISegmentoFilter } from '../interfaces/segmento-filter.interface';
import { ISegmentoResponse } from '../interfaces/segmento-response.interface';
import { ISegmento } from '../interfaces/segmento.interface';

@Injectable({
  providedIn: 'root',
})
export class SegmentoApi {
  private apiUrl = 'v1/environment/segmentos';

  constructor(private http: HttpClient) {}

  fetchSegmentos(filter: ISegmentoFilter): Observable<Partial<ISegmentoResponse>> {
    const params = buildHttpParams(filter);
    return this.http.get<Partial<ISegmentoResponse>>(
      `${environment.pathApi}/${this.apiUrl}`,
      { params }
    );
  }

  fetchList(filter: Partial<ISegmentoFilter>): Observable<ISegmentoResponse> {
    const params = buildHttpParams({ ...filter, sort: 'nivelTipoClassificacao', sortDir: 'asc' });
    return this.http.get<ISegmentoResponse>(
      `${environment.pathApi}/${this.apiUrl}/0/list`,
      { params }
    );
  }

  fetchSegmentoById(id: number): Observable<ISegmento> {
    return this.http.get<ISegmento>(
      `${environment.pathApi}/${this.apiUrl}/${id}`
    );
  }

  create(segmento: ISegmento): Observable<ISegmento> {
    return this.http.post<ISegmento>(
      `${environment.pathApi}/${this.apiUrl}`,
      segmento
    );
  }

  update(id: number, segmento: ISegmento): Observable<ISegmento> {
    return this.http.put<ISegmento>(
      `${environment.pathApi}/${this.apiUrl}/${id}`,
      segmento
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(
      `${environment.pathApi}/${this.apiUrl}/${id}`
    );
  }
}
